var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80078 13.5781C5.80078 14.646 4.93505 15.5117 3.86719 15.5117C2.79933 15.5117 1.93359 14.646 1.93359 13.5781C1.93359 12.5103 2.79933 11.6445 3.86719 11.6445C4.93505 11.6445 5.80078 12.5103 5.80078 13.5781Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1328 16.8008C17.4094 16.8008 16.7399 17.0128 16.1603 17.3599L11.6445 14.5132V10.3555H14.8672V9.06641C14.8672 6.93391 13.1325 5.15625 11 5.15625C8.8675 5.15625 7.13281 6.93391 7.13281 9.06641V10.3555H10.3555V14.5136L5.83971 17.3599C5.26015 17.0128 4.59061 16.8008 3.86719 16.8008C1.73469 16.8008 0 18.5355 0 20.668V22H7.73438V20.668C7.73438 19.745 7.396 18.9078 6.85438 18.2424L10.9998 15.6312L15.1455 18.2424C14.604 18.9079 14.2656 19.745 14.2656 20.668V22H22V20.668C22 18.5355 20.2653 16.8008 18.1328 16.8008Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0664 13.5781C20.0664 14.646 19.2007 15.5117 18.1328 15.5117C17.065 15.5117 16.1992 14.646 16.1992 13.5781C16.1992 12.5103 17.065 11.6445 18.1328 11.6445C19.2007 11.6445 20.0664 12.5103 20.0664 13.5781ZM12.9336 1.93359C12.9336 3.00145 12.0679 3.86719 11 3.86719C9.93214 3.86719 9.06641 3.00145 9.06641 1.93359C9.06641 0.865734 9.93214 0 11 0C12.0679 0 12.9336 0.865734 12.9336 1.93359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignationIcon);
export default __webpack_public_path__ + "static/media/DesignationIcon.aa15dad7ac4fe23009179ec868e2770d.svg";
export { ForwardRef as ReactComponent };